import { render } from "./CvSection.vue?vue&type=template&id=650c7d60&scoped=true&ts=true"
import script from "./CvSection.vue?vue&type=script&lang=ts"
export * from "./CvSection.vue?vue&type=script&lang=ts"

import "./CvSection.vue?vue&type=style&index=0&id=650c7d60&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650c7d60"]])

export default __exports__